// generated by genversion
export const version = '5.0.11';
